import * as THREE from 'three';
const CANVAS_WIDTH = 1400;
const SCROLL_SPEED = 0.42; // canvas pixels per millisecond
const GAP_RATIO = 0.55; // gap between repetitions, as a fraction of canvas width
/** Cap height as a fraction of the canvas height */
const TYPE_SCALE = 0.72;
const BACKGROUND_TOP = '#0a2b1d';
const BACKGROUND_BOTTOM = '#04150e';
const FOREGROUND = '#5dffbe';
const GLOW = '#2bff9d';
/**
 * A single scrolling-text canvas, shared as one texture across every screen in
 * the scene that isn't hosting the website iframe. The type is set large enough
 * that only two or three letters are on a screen at once, so the wall reads as
 * one message drifting across it.
 */
export default class ScreenMarquee {
    constructor(text, aspect) {
        this.text = text;
        this.offset = 0;
        this.canvas = document.createElement('canvas');
        this.canvas.width = CANVAS_WIDTH;
        this.canvas.height = Math.round(CANVAS_WIDTH / aspect);
        this.context = this.canvas.getContext('2d');
        this.font = `bold ${Math.round(this.canvas.height * TYPE_SCALE)}px "Helvetica Neue", Helvetica, Arial, sans-serif`;
        this.context.font = this.font;
        this.stride =
            this.context.measureText(this.text).width +
                this.canvas.width * GAP_RATIO;
        this.texture = new THREE.CanvasTexture(this.canvas);
        this.texture.encoding = THREE.sRGBEncoding;
        this.texture.minFilter = THREE.LinearFilter;
        this.texture.magFilter = THREE.LinearFilter;
        this.texture.generateMipmaps = false;
        this.material = new THREE.MeshBasicMaterial({
            map: this.texture,
            side: THREE.DoubleSide,
            // Screens are the light source of this scene, so they keep their
            // full brightness instead of being pulled down by tone mapping.
            toneMapped: false,
        });
        this.draw();
    }
    draw() {
        const ctx = this.context;
        const w = this.canvas.width;
        const h = this.canvas.height;
        const backdrop = ctx.createLinearGradient(0, 0, 0, h);
        backdrop.addColorStop(0, BACKGROUND_TOP);
        backdrop.addColorStop(1, BACKGROUND_BOTTOM);
        ctx.fillStyle = backdrop;
        ctx.fillRect(0, 0, w, h);
        ctx.font = this.font;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = FOREGROUND;
        ctx.shadowColor = GLOW;
        ctx.shadowBlur = h * 0.14;
        // Draw the text enough times to cover the canvas without a seam
        const start = -(this.offset % this.stride);
        for (let x = start; x < w; x += this.stride) {
            ctx.fillText(this.text, x, h / 2);
        }
        ctx.shadowBlur = 0;
        this.texture.needsUpdate = true;
    }
    update(delta) {
        this.offset += delta * SCROLL_SPEED;
        this.draw();
    }
}
